<div class="t-widget--noPadding">
  <header class="l-flex-column l-align-top summary-box-header">
    <h2 class="t-widgetTitle">
      {{ "translate.dashboard.chatSummaryTitle" | translate }}
    </h2>
    <hr />
  </header>

  <!--UNREAD_BY_ME-->
  <div
    *ngIf="!displayDetailedUnreadMessages"
    class="summary-row no-border"
    [class.allow-hover]="data.unreadMsgByMeCnt > 0"
    (click)="
      data.unreadMsgByMeCnt > 0 ? filterOrdersByChatCode('UNREAD_BY_ME') : null
    "
  >
    <p class="lbl colored">
      {{ "translate.dashboard.chatUnreadByMe" | translate }}
    </p>
    <p class="value">{{ data.unreadMsgByMeCnt }}</p>
  </div>

  <!--UNREAD_BY_ME_FROM_CLINIC-->
  <div
    *ngIf="displayDetailedUnreadMessages"
    class="summary-row no-border"
    [class.allow-hover]="data.unreadMsgClinicToMeCnt > 0"
    (click)="
      data.unreadMsgClinicToMeCnt > 0
        ? filterOrdersByChatCode('UNREAD_BY_ME_FROM_CLINIC')
        : null
    "
  >
    <p class="lbl colored">
      {{ "translate.dashboard.chatUnreadByMeFromClinic" | translate }}
    </p>
    <p class="value">{{ data.unreadMsgClinicToMeCnt || 0 }}</p>
  </div>

  <!--UNREAD_BY_ME_FROM_PLANT-->
  <div
    *ngIf="displayDetailedUnreadMessages"
    class="summary-row no-border"
    [class.allow-hover]="data.unreadMsgPlantToMeCnt > 0"
    (click)="
      data.unreadMsgPlantToMeCnt > 0
        ? filterOrdersByChatCode('UNREAD_BY_ME_FROM_PLANT')
        : null
    "
  >
    <p class="lbl colored">
      {{ "translate.dashboard.chatUnreadByMeFromPlant" | translate }}
    </p>
    <p class="value">{{ data.unreadMsgPlantToMeCnt || 0 }}</p>
  </div>

  <!--UNREAD_PLANT_MGR_CNT -->
  <div
    *ngIf="displayMsgFromPlantAgent"
    class="summary-row no-border"
    [class.allow-hover]="data.unreadPlantMgrCnt > 0"
    (click)="
      data.unreadPlantMgrCnt > 0
        ? filterOrdersByChatCode('UNREAD_PLANT_MGR_CNT')
        : null
    "
  >
    <p class="lbl colored">
      {{ "translate.dashboard.chatUnreadFromPlantMgrCnt" | translate }}
    </p>
    <p class="value">{{ data.unreadPlantMgrCnt }}</p>
  </div>

  <!--UNREAD_FROM_ME-->
  <div
    class="summary-row no-border"
    [class.allow-hover]="data.unreadMsgFromMeCnt > 0"
    (click)="
      data.unreadMsgFromMeCnt > 0
        ? filterOrdersByChatCode('UNREAD_FROM_ME')
        : null
    "
  >
    <p class="lbl colored">
      {{ "translate.dashboard.chatUnreadMine" | translate }}
    </p>
    <p class="value">{{ data.unreadMsgFromMeCnt }}</p>
  </div>

  <!--ALL MESSAGES-->
  <div
    class="summary-row no-border"
    [class.allow-hover]="data.allMsgCnt > 0"
    (click)="data.allMsgCnt > 0 ? filterOrdersByChatCode('ALL_MSG') : null"
  >
    <p class="lbl colored">
      {{ "translate.dashboard.chatAllMsg" | translate }}
    </p>
    <p class="value">{{ data.allMsgCnt }}</p>
  </div>

  <!--DUE DATE UPDATES-->
  <div
    *ngIf="displayDueDateUpdates"
    class="summary-row no-border"
    [class.allow-hover]="data.dueDateUpdatesCnt > 0"
    (click)="
      data.dueDateUpdatesCnt > 0
        ? filterOrdersByChatCode('DUE_DATE_UPDATE')
        : null
    "
  >
    <p class="lbl colored">
      {{ "translate.dashboard.dueDateUpdatesCnt" | translate }}
    </p>
    <p class="value">{{ data.dueDateUpdatesCnt }}</p>
  </div>
</div>
